import React from "react";
import {Grid, Typography} from "@mui/material";
import {lxStyled, useLxTranslations} from "@lxo-blocks/react";
import {MFARESET_FORM_TRANSLATION} from "./MfaResetForm.translation.de";

const PREFIX = 'ResetMfaHint';
const classes = {
    resetMfaHint: `${PREFIX}-resetMfaHint`,
    headline: `${PREFIX}-headline`,
    description: `${PREFIX}-description`
}
const ResetMfaHintContainer = lxStyled(Grid)(({theme}) => ({
    [`.${classes.resetMfaHint}`]: {
        backgroundColor: `rgba(240, 125, 0, 0.1)`,
        width: "100%"
    },
    [`.${classes.headline}`]: {
        color: `${theme.palette.warning.main}`,
        fontWeight: `bold`
    },
    [`.${classes.description}`]: {
        color: `${theme.palette.warning.main}`,
    }
}));

export interface ResetMfaHintProps {
    sx?: any;
}

export default function ResetMfaHint(props: ResetMfaHintProps) {
    const {t} = useLxTranslations(MFARESET_FORM_TRANSLATION);
    return <ResetMfaHintContainer container
                                  sx={props.sx}>
        <Grid className={`${classes.resetMfaHint}`} sx={{p: 2}} item>
            <Typography className={`${classes.headline}`} component="div"
                        variant="body1">{t("RESET_MFA_HINT_HEADLINE")}</Typography>
            <Typography className={`${classes.description}`} component="div"
                        variant="body2">{t("RESET_MFA_HINT")}</Typography>
        </Grid>
    </ResetMfaHintContainer>
}